export default __webpack_public_path__ + "static/media/pic12.95a82dd7.jpg";